import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "trigger"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    this.syncTrigger()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.syncTrigger()
  }

  syncTrigger() {
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", String(!this.menuTarget.classList.contains("hidden")))
    }
  }

  // Close when clicking outside
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  connect() {
    this._outsideClickHandler = this.clickOutside.bind(this)
    document.addEventListener("click", this._outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickHandler)
  }
}
